var _rect, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOccupiedBlockedUnisex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 20,
    viewBox: "0 0 64 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_38_760",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 19,
    rx: 9.5,
    fill: "#D9D9D9",
    stroke: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_38_760)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 19,
    rx: 9.5,
    stroke: "#AEB0BD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.1301,
    y: -14.412,
    width: 55.0175,
    height: 48,
    transform: "rotate(17.2535 39.1301 -14.412)",
    fill: "#474B5A"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.8003 6.20648C51.5341 5.94027 51.1041 5.94027 50.8379 6.20648L47.5 9.53754L44.1621 6.19966C43.8959 5.93345 43.4659 5.93345 43.1997 6.19966C42.9334 6.46587 42.9334 6.8959 43.1997 7.16212L46.5375 10.5L43.1997 13.8379C42.9334 14.1041 42.9334 14.5341 43.1997 14.8003C43.4659 15.0666 43.8959 15.0666 44.1621 14.8003L47.5 11.4625L50.8379 14.8003C51.1041 15.0666 51.5341 15.0666 51.8003 14.8003C52.0666 14.5341 52.0666 14.1041 51.8003 13.8379L48.4625 10.5L51.8003 7.16212C52.0597 6.90273 52.0597 6.46587 51.8003 6.20648Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOccupiedBlockedUnisex);
export default __webpack_public_path__ + "static/media/occupied-blocked-unisex.d694c15d8169f9c797a276c13aad86c6.svg";
export { ForwardRef as ReactComponent };